module.exports = __webpack_public_path__ + "img/Nutrilon_MCM_C2_2023_580x312.cf12015a.png";